export const etrSliderLimit = 20;
export const etrSliderStep = 0.005;
export const etrSliderSmallStep = 0.0001;
